import { isAuthenticated } from '@connected/api-client/lib/authentication';
import { DOMAIN_KEYS } from '@connected/api-client/lib/portal';
import { generateSSOUrl } from '@connected/api-client/lib/sso';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * @deprecated This route is kept for backward compatibility with older versions of elektra-app.
 * New SSO flow should use the login page directly, which now handles SSO redirects via generateSSOUrl().
 * This route can be removed once all older app versions are no longer in use.
 */
export const Route = createFileRoute('/(shared)/redirect/')({
    validateSearch: z.object({
        redirectHost: z.string().optional(),
        redirectPath: z.string().optional(),
        from: z.enum(DOMAIN_KEYS).optional(),
    }),
    beforeLoad: async ({ search }) => {
        if (isAuthenticated()) {
            // If we have a valid domain key, redirect via SSO
            if (search.from) {
                const redirectURL = generateSSOUrl({
                    targetDomain: search.from,
                    redirectPath: search.redirectPath,
                });

                if (redirectURL) {
                    window.location.href = redirectURL;
                    return;
                }
            }

            // Fallback: redirect to home if no valid from domain
            throw redirect({ to: '/' });
        }
        else {
            // Not authenticated: redirect to login preserving search params
            throw redirect({
                to: '/login',
                search,
            });
        }
    },
});
